<template>
    <div :class="className">
        <slot />
    </div>
</template>

<script setup lang="ts">
import { IFieldGroup } from '../types';

withDefaults(defineProps<IFieldGroup>(), {
    className: 'd-flex ga-4'
});
</script>
